// src/components/login/MicrosoftIcon.tsx
import React from 'react';

interface Props {
    size?: number;
    className?: string;
}

/**
 * Four-pane Microsoft logo with sharper corners,
 * slightly larger gaps, and tweaked brand gradients:
 * – darker red
 * – deeper ↔ lighter green
 * – brighter blue
 * – warm, orange-tinted yellow
 */
export const MicrosoftIcon: React.FC<Props> = ({
                                                   size = 32,
                                                   className,
                                               }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        aria-label="Microsoft"
    >
        <defs>
            <linearGradient id="redGrad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#D82115FF" />  {/* darker red */}
                <stop offset="100%" stopColor="#E92215" /> {/* bright red */}
            </linearGradient>

            <linearGradient id="greenGrad" x1="0" y1="1" x2="1" y2="0">
                <stop offset="0%" stopColor="#107C10" />  {/* deep green */}
                <stop offset="100%" stopColor="#92C353" /> {/* light green */}
            </linearGradient>

            <linearGradient id="blueGrad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#69C0FF" />  {/* bright sky-blue */}
                <stop offset="100%" stopColor="#0078D7" /> {/* classic MS blue */}
            </linearGradient>

            <linearGradient id="yellowGrad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#FD8801" />  {/* darker yellow / orange */}
                <stop offset="100%" stopColor="#FFCB02" /> {/* bright yellow */}
            </linearGradient>
        </defs>

        {/* top-left */}
        <rect x="3" y="3" width="8" height="8" rx="0.5" fill="url(#redGrad)" />

        {/* top-right */}
        <rect x="13" y="3" width="8" height="8" rx="0.5" fill="url(#greenGrad)" />

        {/* bottom-left */}
        <rect x="3" y="13" width="8" height="8" rx="0.5" fill="url(#blueGrad)" />

        {/* bottom-right */}
        <rect x="13" y="13" width="8" height="8" rx="0.5" fill="url(#yellowGrad)" />
    </svg>
);
